<template>
  <div id="app">
    <router-view></router-view>
    <div
      v-if="showBanner"
      id="cookies"
      :class="activeConsent ? 'cookies-consent-open' : ''"
    >
      <div class="content-info">
        <div class="text" v-if="!activeConsent">
          <p>
            Este site utiliza cookies apenas para melhorar o funcionamento e
            proporcionar uma boa experiência ao usuário. Clique em "Aceitar"
            para concordar ou "Gerenciar" para ver mais informações.
          </p>
        </div>
        <div class="actions">
          <button
            type=""
            class="btn btn-gerenciar"
            v-if="!activeConsent"
            @click="activeConsent = true"
          >
            Gerenciar
          </button>
          <button
            type=""
            class="btn"
            v-if="!activeConsent"
            @click="enabledOrDisabledAnalytics(true)"
          >
            Aceitar
          </button>
        </div>
      </div>
      <div v-if="activeConsent">
        <!-- <label class="switch">
        <input type="checkbox" v-model="googleAnalyticsEnabled" />
        <div class="slider round"></div>
      </label> -->
        <h3>Necessários</h3>
        <p>
          Cookies necessários desempenham um papel vital nas funcionalidades
          fundamentais do site, e o site não operará conforme o esperado sem
          eles. Importante destacar que esses cookies não coletam informações
          pessoais identificáveis.
        </p>
        <p></p>
        <table class="table table-responsive table-striped">
          <tbody>
            <tr>
              <th>Nome do cookie</th>
              <th>Tempo de vencimento</th>
              <th>Descrição</th>
            </tr>
            <tr>
              <td>
                <code>cookies_consent</code>
              </td>
              <td>1 ano</td>
              <td>
                Este cookie é definido para lembrar o consentimento dos usuários
                para o uso de cookies analíticos.
              </td>
            </tr>
            <!-- <tr>
              <td><code>SEARCH_SAMESITE</code></td>
              <td>2 anos</td>
              <td>
                Este cookie é usado para evitar que o navegador envie este
                cookie junto com solicitações entre sites.
              </td>
            </tr>
            <tr>
              <td><code>SIDCC</code></td>
              <td>2 anos</td>
              <td>
                Cookie de segurança para proteger os dados de um usuário contra
                acesso não autorizado.
              </td>
            </tr>
            <tr>
              <td><code>SSID</code></td>
              <td>2 anos</td>
              <td>
                Estes são cookies essenciais do site, utilizados pelo google
                reCAPTCHA. Esses cookies usam um identificador exclusivo para
                fins de rastreamento.
              </td>
            </tr>
            <tr>
              <td><code>SAPISID</code></td>
              <td>2 anos</td>
              <td>
                Estes são cookies essenciais do site, utilizados pelo google
                reCAPTCHA. Esses cookies usam um identificador exclusivo para
                fins de rastreamento.
              </td>
            </tr>
            <tr>
              <td><code>NID</code></td>
              <td>6 meses</td>
              <td>
                Estes são cookies essenciais do site, utilizados pelo google
                reCAPTCHA. Esses cookies usam um identificador exclusivo para
                fins de rastreamento.
              </td>
            </tr> -->
            <tr>
              <td><code>_GRECAPTCHA </code></td>
              <td>5 meses e 27 dias</td>
              <td>
                Este cookie é definido pelo Google. Além de certos cookies
                padrão do Google, o reCAPTCHA define um cookie necessário
                (_GRECAPTCHA) quando executado com a finalidade de fornecer sua
                análise de risco.
              </td>
            </tr>
          </tbody>
        </table>

        <h3>Analíticos</h3>
        <p>
          Esses cookies ajudam a fornecer informações sobre métricas do número
          de visitantes, taxa de rejeição, fonte de tráfego, etc. Os dados
          coletados são apenas para fins estatísticos.
        </p>
        <table class="table table-responsive table-striped">
          <tbody>
            <tr>
              <th>Nome do cookie</th>
              <th>Tempo de vencimento</th>
              <th>Descrição</th>
            </tr>
            <tr>
              <td>
                <code>_<wbr />ga</code>
              </td>
              <td>2 anos</td>
              <td>Usado para distinguir usuários.</td>
            </tr>
            <tr>
              <td>
                <code>_<wbr />ga_M3NVL3RKBD</code>
              </td>
              <td>2 anos</td>
              <td>Usado para manter o estado da sessão.</td>
            </tr>
            <!-- <tr>
              <td>
                <code>_<wbr />gid</code>
              </td>
              <td>24 horas</td>
              <td>Usado para distinguir usuários.</td>
            </tr>
            <tr>
              <td>
                <code>_<wbr />gat</code>
              </td>
              <td>1 minuto</td>
              <td>Usado para controlar a taxa de solicitação.</td>
            </tr> -->
            <!-- <tr>
            <td>
              <code>AMP_<wbr />TOKEN</code>
            </td>
            <td>30 segundos a 1 ano</td>
            <td>
              Contém um token que pode ser usado para recuperar um Client-ID do
              serviço AMP Client ID. Outros valores possíveis indicam
              desativação, solicitação em andamento ou erro ao recuperar um
              Client-ID desse serviço.
            </td>
          </tr>
          <tr>
            <td>
              <code>_<wbr />gac_<wbr />&lt;property-id&gt;</code>
            </td>
            <td>90 dias</td>
            <td>
              Contém informações relacionadas à campanha para o usuário. Se você
              vinculou suas contas do Google Analytics e do Google AdWords, as
              tags de conversão de site do Google AdWords analisarão esse
              cookie, a menos que você o desative.
              <a href="//support.google.com/adwords/answer/7521212?hl=pt-br"
                >Saiba mais</a
              >.
            </td>
          </tr> -->
          </tbody>
        </table>

        <div class="cookies-actions">
          <button
            type=""
            class="btn btn-green"
            @click="enabledOrDisabledAnalytics(true)"
          >
            <i class="icofont-check"></i> Aceitar
          </button>
          <button
            type=""
            class="btn btn-red"
            @click="enabledOrDisabledAnalytics(false)"
          >
            <i class="icofont-close"></i> Recusar
          </button>
        </div>
      </div>
    </div>
    <!-- <div
      v-if="!showBanner"
      id="mini-cookies"
      @click="optionsCookies()"
      :class="positionMiniCookies"
    >
      <i class="icofont-tools"></i> <span> Opções de cookies</span>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: '',
    // all titles will be injected into this template
    titleTemplate: '%s',
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description',
        content:
          'Um painel de gestão para ajudar profissionais de saúde e gestores no atendimento aos requisitos do financimento federal da APS.',
      },
      { name: 'robots', content: 'index,follow' },
    ],
  },
  components: {},
  data() {
    return {
      allowCookies: null,
      activeConsent: false,
      googleAnalyticsEnabled: false,
    }
  },
  created() {
    if (this.$cookies.isKey('cookies_consent')) {
      this.allowCookies = this.$cookies.get('cookies_consent') === 'true'
    } else {
      this.allowCookies = null
    }
  },
  computed: {
    showBanner() {
      const isPep = this.$route.path.includes('/pep')
      const isIframe = window.self !== window.top

      return this.allowCookies === null && !isPep && !isIframe
    },
    positionMiniCookies() {
      if (this.$route.path == '/') {
        return 'right'
      }
      return 'left'
    },
  },
  watch: {
    allowCookies(newVal) {
      if (newVal !== null) {
        this.$cookies.set('cookies_consent', newVal.toString(), '1y')
        if (newVal) {
          this.$gtag.optIn()
        } else {
          this.$gtag.optOut()
        }
      }
    },
  },
  methods: {
    enabledOrDisabledAnalytics(val) {
      this.allowCookies = val
    },

    optionsCookies() {
      this.allowCookies = null
      this.activeConsent = true
    },

    deleteGACookies() {
      // Replace "ga_" with the appropriate prefix used by your Google Analytics cookies
      var cookies = document.cookie.split(';')

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim()
        if (cookie.indexOf('_ga') === 0) {
          var cookieParts = cookie.split('=')
          var cookieName = cookieParts[0]
          document.cookie =
            cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        }
      }
    },
  },
}
</script>

<style lang="scss">
#cookies {
  position: fixed;
  background-color: #fff;
  color: #565662;
  border: 1px solid #e5e7eb;
  top: auto;
  right: 0;
  bottom: 0;
  left: 50%;
  padding: 1.25rem;
  z-index: 9999999999999;
  transform: translate(-50%, 0%);

  @media screen and (max-width: 656px) {
    overflow-y: scroll;
    left: 0;
    transform: translate(0, 0);
    &.cookies-consent-open {
      height: 100%;
      overflow-y: scroll;
    }
  }
  @media screen and (min-width: 657px) and (max-width: 807px) {
    overflow-y: scroll;
    left: 0;
    transform: translate(0, 0);
  }

  @media screen and (min-width: 808px) and (max-width: 1023px) {
    overflow-y: scroll;
    left: 0;
    transform: translate(0, 0);
  }

  @media screen and (min-width: 1024px) and (max-width: 1265px) {
  }
  h3 {
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
  }
  p {
    margin: 0;
    text-align: left;
    font-size: 15px;
  }
  table {
    margin-top: 15px;
  }
  .content-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    @media screen and (max-width: 656px) {
      flex-direction: column;
    }
    @media screen and (min-width: 657px) and (max-width: 807px) {
      flex-direction: column;
    }

    @media screen and (min-width: 808px) and (max-width: 1023px) {
      flex-direction: column;
    }

    @media screen and (min-width: 1024px) and (max-width: 1265px) {
    }
    .icon {
      i {
        font-size: 60px;
      }
    }
    .text {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 10px;
      button {
        background-color: rgb(229, 231, 235);
        border-bottom-color: rgb(229, 231, 235);
        color: #000;
        font-weight: normal;
        border-radius: 7px;
      }
    }
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
    margin-top: 10px;
    input {
      display: none;
    }
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      &:before {
        position: absolute;
        content: '';
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
    }
    input:checked + .slider {
      background-color: #101010;
    }
    input:focus + .slider {
      box-shadow: 0 0 1px #101010;
    }
    input:checked + .slider:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }
    .slider.round {
      border-radius: 34px;
    }
    .slider.round:before {
      border-radius: 50%;
    }
  }
  .cookies-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 15px;
    gap: 10px;
    .btn-green {
      background: green;
    }
    .btn-red {
      background: red;
    }
  }
}

#mini-cookies {
  position: fixed;
  z-index: 999;
  background-color: #000;
  color: #fff;
  border: 1px solid #fff;
  padding: 12px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 26px;
  &.login {
    left: 1.5rem;
    bottom: 6rem;
  }
  &.left {
    left: 0rem;
    bottom: 0rem;
  }
  &.right {
    right: 5rem;
    bottom: 1.2rem;
  }
  &.center {
    bottom: 0;
    left: 50%;
    z-index: 9999999999999;
    transform: translate(-50%, 0%);
  }
}
</style>
